<template>
    <div class="video">
        <v-img :src="thumbnailUrl" height="144" cover> </v-img>
        <p style="font-size: 12px">{{ title }}</p>
        <p style="font-size: 10px; color: #7c7c7c; text-align: right">
            {{ date }}
        </p>
    </div>
</template>

<script>
import { defineComponent, ref, onMounted } from "vue";
import TrayArrowDown from "vue-material-design-icons/TrayArrowDown.vue";

export default defineComponent({
    props: {
        title: {
            type: String,
            default: "",
        },
        video: {
            type: String,
            default: "",
        },
        date: {
            type: String,
            default: "",
        },
    },
    components: {
        TrayArrowDown,
    },
    setup(props) {
        const thumbnailUrl = ref("");

        function extractVideoID(url) {
            const urlParams = new URLSearchParams(new URL(url).search);
            return urlParams.get("v");
        }

        onMounted(() => {
            const videoId = extractVideoID(props.video);
            thumbnailUrl.value = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
        });
        return {
            thumbnailUrl,
        };
    },
});
</script>

<style scoped>
button {
    padding: 8px;
    border: 0.5px solid #b0b0b0;
}

.video {
    width: 100%;
    padding: 24px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.v-img__img--contain {
    object-fit: fill !important;
}
</style>
